
    import './styles.scoped.css';
    export default {
  "option": "awsui_option_1p2cx_12phk_13",
  "disabled": "awsui_disabled_1p2cx_12phk_50",
  "parent": "awsui_parent_1p2cx_12phk_53",
  "highlighted": "awsui_highlighted_1p2cx_12phk_56",
  "content": "awsui_content_1p2cx_12phk_60",
  "label-content": "awsui_label-content_1p2cx_12phk_67",
  "label": "awsui_label_1p2cx_12phk_67",
  "tag": "awsui_tag_1p2cx_12phk_74",
  "label-tag": "awsui_label-tag_1p2cx_12phk_75",
  "label-prefix": "awsui_label-prefix_1p2cx_12phk_85",
  "tags": "awsui_tags_1p2cx_12phk_98",
  "description": "awsui_description_1p2cx_12phk_99",
  "selected": "awsui_selected_1p2cx_12phk_110",
  "icon": "awsui_icon_1p2cx_12phk_124",
  "filtering-match-highlight": "awsui_filtering-match-highlight_1p2cx_12phk_131",
  "trigger-variant": "awsui_trigger-variant_1p2cx_12phk_146",
  "custom-content": "awsui_custom-content_1p2cx_12phk_152"
};
  